import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

export type TableOwner = {
  id: string;
  type: string;
  name: string;
  displayName?: string;
  deleted?: boolean;
};

export type TableTag = {
  tagFQN: string;
  name?: string;
  displayName?: string;
  description?: string;
  source: string;
  labelType: string;
  state: string;
};

export type TableDomain = {
  id: string;
  type: string;
  name: string;
  displayName?: string;
  description?: string;
};

export type TableDataProduct = {
  id: string;
  type: string;
  name: string;
  displayName?: string;
  description?: string;
};

export type TableProfile = {
  rowCount?: number;
  columnCount?: number;
  sizeInByte?: number;
};

export type TableUsageStats = {
  count: number;
  percentileRank: number;
};

export type TableUsageSummary = {
  dailyStats: TableUsageStats;
  weeklyStats: TableUsageStats;
  monthlyStats: TableUsageStats;
  date: string;
};

export type DatabaseTable = {
  id: string;
  name: string;
  displayName?: string;
  fullyQualifiedName: string;
  description?: string;
  version?: number;
  updatedAt?: string | number;
  updatedBy?: string;
  href?: string;
  deleted?: boolean;
  owners?: TableOwner[];
  tags?: TableTag[];
  domains?: TableDomain[];
  dataProducts?: TableDataProduct[];
  profile?: TableProfile;
  usageSummary?: TableUsageSummary;
};

export type TablesResponse = {
  data: DatabaseTable[];
  paging?: {
    total: number;
    after?: string;
    before?: string;
  };
};

export const fetchDatabaseTables = async (
  databaseSchemaFqn: string,
  includeDeleted: boolean = false
): Promise<TablesResponse> => {
  try {
    const response = await openMetadataApiClient.get<TablesResponse>('/tables', {
      params: {
        limit: 1000,
        fields: 'tags,owners,domains,profile,usageSummary',
        databaseSchema: databaseSchemaFqn,
        include: includeDeleted ? 'deleted' : 'non-deleted',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Failed to fetch database tables:', error);
    throw error;
  }
};
